const textStyles = {
  h1: {
    fontSize: {
      base: '22px',
      md: '28px'
    },
    fontWeight: 600,
    fontFamily: 'var(--chakra-fonts-main)'
  },
  h2: {
    fontSize: {
      base: '18px',
      md: '20px'
    },
    fontWeight: 600,
    fontFamily: 'var(--chakra-fonts-main)'
  }
};

export default textStyles;
